import { Routes as Switch, Route } from "react-router-dom";

import GATracker from "./GATracker";
import PrivateRoute from "./PrivateRoute";

import Main from "../pages/Main";
import Releases from "../pages/Releases";
import Products from "../pages/Products";
import SearchResult from "../pages/SearchResult";
import Order from "../pages/Order";
import Login from "../pages/Login";
import NoMatch from "../pages/NoMatch";
import OrderImport from "../pages/OrderImport";
import Unauthorized from "../pages/Unauthorized";
import LoginForm from "../pages/Login/CentraleConexao";

// Wrap components with GATracker
const TrackedMain = GATracker(Main);
const TrackedReleases = GATracker(Releases);
const TrackedProducts = GATracker(Products);
const TrackedSearchResult = GATracker(SearchResult);
const TrackedOrder = GATracker(Order);
const TrackedOrderImport = GATracker(OrderImport);
const TrackedCentraleConexao = GATracker(LoginForm);

const Routes = () => (
  <Switch>
    <Route path="/login/:token/:project/:coreIndustry" element={<Login />} />
    <Route path="/unauthorized" element={<Unauthorized />} />
    <Route path="/centraleconexao" element={<TrackedCentraleConexao />} />

    <Route element={<PrivateRoute />}>
      <Route path="/" element={<TrackedMain />} />
      <Route path="/lancamentos" element={<TrackedReleases />} />
      <Route path="/produtos" element={<TrackedProducts />} />
      <Route
        path="/produtos/buscar/:term/:industry/:type/:categoryGroup/:category/:mixIdeal"
        element={<TrackedSearchResult />}
      />
      <Route path="/pedido" element={<TrackedOrder />} />
      <Route path="/pedido/importar" element={<TrackedOrderImport />} />
    </Route>

    <Route path="*" element={<NoMatch />} />
  </Switch>
);

export default Routes;
